module.exports = __webpack_public_path__ + "img/sm-step-one-img.61cfcd4.svg";